import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';

const actions = {
  async getPermissions({ commit }) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.permissions,
        isToken: true,
      });
      commit('GET_PERMISSIONS_SUCCESS', data);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async updatePermissions({ dispatch }, value) {
    const { id, permissions, pagePermissions } = value;
    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.permissions}/${id}`,
        body: { permissions, pagePermissions },
        isToken: true,
      });
      notificationWithIcon('success', 'Permissions changed');
      dispatch('getPermissions');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
};

export default actions;
